module.exports = __webpack_public_path__ + "img/1728435621181-Screenshot_9-10-2024_85940_www.bing.com.jpeg.6d02360c.webp";